import React from "react";
import "mathlive";

const MathFormulaViewer = (props) => {
  const { value, boxSize } = props;

  // Function to split the value into chunks of 100 characters each
  const chunkString = (str, size) => {
    const chunkedArr = [];
    let index = 0;
    while (index < str.length) {
      chunkedArr.push(str.slice(index, index + size));
      index += size;
    }
    return chunkedArr;
  };

  // Split the value into chunks of 100 characters
  const valueChunks = chunkString(value, boxSize ? boxSize : 105);

  return (
    <>
      {valueChunks.map((chunk, index) => (
        <math-field key={index} disabled>
          {chunk}
        </math-field>
      ))}
    </>
  );
};

export default MathFormulaViewer;
